import React from 'react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import TableChartIcon from '@mui/icons-material/TableChart';
import ImageIcon from '@mui/icons-material/Image';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import FolderZipIcon from '@mui/icons-material/FolderZip';

/**
 * Get appropriate icon component for file extension
 * Returns a React component with appropriate styling
 *
 * @param {string} extension - File extension (e.g., 'pdf', 'docx')
 * @param {string} size - Icon size: 'small' (24px), 'medium' (28px), or 'large' (32px)
 * @returns {React.ReactElement} - Icon component with styling
 */
export const getFileIcon = (extension, size = 'medium') => {
    const ext = extension?.toLowerCase();
    const fontSize = size === 'small' ? 24 : size === 'large' ? 32 : 28;

    const iconProps = { sx: { fontSize } };

    switch (ext) {
        case 'pdf':
            return <PictureAsPdfIcon {...iconProps} sx={{ ...iconProps.sx, color: '#d32f2f' }} />;
        case 'doc':
        case 'docx':
            return <DescriptionIcon {...iconProps} sx={{ ...iconProps.sx, color: '#1976d2' }} />;
        case 'xls':
        case 'xlsx':
            return <TableChartIcon {...iconProps} sx={{ ...iconProps.sx, color: '#388e3c' }} />;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return <ImageIcon {...iconProps} sx={{ ...iconProps.sx, color: '#f57c00' }} />;
        case 'txt':
            return <TextSnippetIcon {...iconProps} sx={{ ...iconProps.sx, color: '#616161' }} />;
        case 'zip':
        case 'rar':
            return <FolderZipIcon {...iconProps} sx={{ ...iconProps.sx, color: '#7b1fa2' }} />;
        default:
            return (
                <InsertDriveFileIcon {...iconProps} sx={{ ...iconProps.sx, color: '#757575' }} />
            );
    }
};
